import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b5545536&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b5545536&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5545536",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5545536')) {
      api.createRecord('b5545536', component.options)
    } else {
      api.reload('b5545536', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b5545536&scoped=true", function () {
      api.rerender('b5545536', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/ezpay/components/CountrySelect/index.vue"
export default component.exports